import React from 'react'
import { SWRConfig } from 'swr'
// import { dygcDomain } from '@utils/constants'
import axios from './axios'

const getfetcher = (url) => {
  return axios.get(url).then((res) => res)
}
const postfetcher = (url) => {
  return axios.post(url, {}).then((res) => res)
}
const SwrConfig = ({ children, method = 'get' }) => {
  return (
    <SWRConfig
      value={{
        fetcher: method === 'get' ? getfetcher : postfetcher,
        revalidateOnFocus: false,
        dedupingInterval: 300000,
        onError: (error) => {
          if (error.status === 401) {
            // window.location.href = `${dygcDomain}/login?url=${window.location.href}`
          }
        },
      }}
    >
      {children}
    </SWRConfig>
  )
}

export default SwrConfig
